import { useContext, createContext } from 'react'
import { initialState } from '../reducer/otInboundDifference'
import { actionTypes } from '../types/actionTypes'
import { ReducerOtInboundDifference } from '../types/reducerTypes'

interface OtInboundDifferenceContext {
  state: ReducerOtInboundDifference
  dispatch: React.Dispatch<actionTypes>
}

// Se crea un Contexto el cual le asignamos el tipo de CountContext el cual tendra nuestro state del reducer y nuestro dispatch
export const OtInboundDifferenceContext =
  createContext<OtInboundDifferenceContext>({
    state: initialState,
    dispatch: () => {}
  })

// Se crea un custom hook para validar que nuestro contexto no contenta una instancia indefinida
// y una vez se valide que si contiene una instancia, lo retornamos para su uso posterior

export const useOtInboundDifference = () => {
  const context = useContext(OtInboundDifferenceContext)
  if (context === undefined) {
    throw new Error('useOtInboundDifference must be used with a Provider')
  }

  return context
}
